export default {
  title: 'DIY Modeler',
  subtitle: 'Modelos simples y genéricos que puedes crear de forma independiente, con tus datos y nuestra tecnología.',
  createModel: 'Crear Modelo',
  cancel: 'Cancelar',
  wizardUploadHint: 'Haga clic en el botón de abajo para subir sus datos.',
  wizardDownloadTemplateText: 'Puedes descargar una copia de la plantilla de datos',
  wizardDownloadTemplateLink: 'aquí',
  unsupportedFileType: 'Tipo de archivo no soportado. Solo se aceptan archivos .xlsx.',
  errorUploadingFile: 'Error al subir el archivo. Por favor intente de nuevo.',
  uploadingFile: 'Subiendo archivo',
  validationErrorsTitle: 'Errores de Validacion',
  sheetGeneral: 'General',
  errorSingular: 'error',
  errorPlural: 'errores',
  close: 'Cerrar',
  rows: 'filas',
  andMore: 'Y {count} más',
  downloadCsv: 'Exportar Detalles de Errores como CSV',
  priorsMarketingTitle: 'Rango de Atribucion Total de Marketing',
  priorsMarketingDescription: 'Defina el rango esperado para la contribucion total de todas las actividades de marketing a su KPI.',
  priorsMin: 'Min',
  priorsMax: 'Max',
  priorsChannelTitle: 'Rango de ROAS por Medio',
  priorsChannelDescription: 'Habilite cada canal de medios para el cual desee establecer un rango de ROAS objetivo. Los canales deshabilitados no tendrán restricciones.',
  priorsNoChannels: 'Suba y valide un archivo de datos para ver los canales de medios disponibles.',
  priorsAdstockTitle: 'Medios de Decaimiento Rapido',
  priorsAdstockDescription: 'Seleccione todos los canales de medios cuyos efectos decaen rapidamente con el tiempo.',
  priorsNoChannelsAdstock: 'Suba y valide un archivo de datos para ver los canales de medios disponibles.',
  priorsSaturationTitle: 'Seleccionar Restricción',
  priorsSaturationOptionAttribution: 'Rango de Atribución Total de Marketing',
  priorsSaturationOptionRoas: 'Rango de ROAS por Medio',
  priorsStepAttribution: 'Atribución',
  priorsStepRoas: 'ROAS',
  priorsStepAttributionRoas: 'Restricciones',
  priorsStepDecay: 'Decaimiento Rápido',
  generateNameAlreadyUsed: 'Este nombre ya esta en uso.',
  generateNameExistsInClients: 'Ya existe un modelo de cliente con este nombre.',
  errorGeneratingModel: 'Error al generar el modelo. Por favor intente de nuevo.',
  wizardTitle: 'Nuevo Modelo Automatico',
  wizardStepDataUpload: 'Carga de Datos',
  wizardModelNameLabel: 'Nombre del Modelo',
  wizardSelectFile: 'Seleccionar Archivo de Datos',
  wizardReUpload: 'Re-subir Archivo',
  wizardValidating: 'Validando sus datos...',
  wizardValidSuccess: 'Datos validados exitosamente',
  wizardValidFailed: 'La validacion fallo',
  wizardValidationIssuesIntro: 'Su plantilla de datos contiene los siguientes problemas que deben resolverse para continuar:',
  wizardViewErrors: 'Ver Errores',
  wizardStepModelName: 'Nombre del Modelo',
  wizardModelNameDescription: 'Elija un nombre para su modelo. Este nombre debe ser unico.',
  wizardGenerateButton: 'Generar',
  wizardGenerating: 'Generando...',
  headerModelName: 'Nombre del Modelo',
  headerDateCreated: 'Creado',
  headerCreatedBy: 'Creado Por',
  headerDetails: 'Ajustes',
  headerStatus: 'Estado',
  detailsAttribution: 'Atribución',
  detailsRoas: 'ROAS',
  detailsFastDecay: 'Dec. Rápido',
  detailsAttributionRange: 'Rango de atribución: {min}% – {max}%',
  detailsRoasChannels: 'Rangos de ROAS:',
  detailsFastDecayChannels: 'Canales de decaimiento rápido:',
  statusPending: 'Pendiente',
  statusUploaded: 'Cargado',
  statusGenerating: 'Generando Modelo',
  statusGenerated: 'Generado',
  statusError: 'Error',
  deleteModel: 'Eliminar Modelo',
  deleteWarningTitle: 'Eliminar Modelo',
  deleteModelMessage: '¿Está seguro de que desea eliminar permanentemente "{name}"? Esta acción no se puede deshacer.',
  deleteModelMessageTrash: '¿Está seguro de que desea eliminar "{name}"? Podrá recuperarlo durante 7 días solicitándolo a un administrador.',
  deleteModelConfirm: 'Eliminar',
  delete: 'Eliminar',
  unnamedModel: 'Modelo Sin Nombre',
  priorsMaxBelowMin: 'Max debe ser > Min',
  priorsValueMustBePositive: 'Debe ser > 0',
  priorsValueCannotBeNegative: 'Debe ser >= 0',
  priorsChannelMaxLimit: 'Debe ser <= 10',
  priorsValueOutOfRange: 'Debe estar entre 0 y 100',
  dataFrequencyLabel: 'Frecuencia de Datos',
  dataFrequencyDescription: 'Seleccione la frecuencia de sus datos antes de subirlos.',
  dataFrequencyWeekly: 'Semanal',
  dataFrequencyMonthly: 'Mensual',
  downloadDataTemplate: 'Descargar Plantilla de Datos',
  downloadAssemblerPkl: 'Descargar Assembler PKL',
  printConfigMap: 'Imprimir Mapa de Configuración',
  printJson: 'Imprimir JSON',
  viewReport: 'Ver Reporte',
  highMapeWarning: 'La precision del modelo puede ser baja',
  modelNameNoteTitle: 'Nota',
  modelNameNoteText: 'Los graficos del Reporte del Modelo muestran los ultimos 3 años de datos. Sus restricciones de ROAS y Atribucion se aplican a todo su conjunto de datos, por lo que los valores mostrados en los graficos pueden estar fuera de los rangos especificados. Estas diferencias son esperadas debido a este enfoque.',
  wizardMediaChannelsDetected: 'Canales de medios detectados',
  wizardChannelOriginalName: 'Nombre Original',
  wizardChannelDisplayName: 'Nombre para Mostrar'
}
